import {setActivePoint} from '../actions';
import * as ActionTypes from '../actions/actionTypes';

const INTER_TAB_STORAGE_KEY = 'interTabMessage';

const _instanceId = Math.random();
let _blackout = false;

function _hasMoved(p1, p2) {
  return p1 && p2 && (p1.lat !== p2.lat || p1.lon !== p2.lon);
}

function _sendMessage(action) {
  const message = {
    from: _instanceId,
    type: action.type,
    action
  };

  if (!_blackout) {
    localStorage.setItem(INTER_TAB_STORAGE_KEY, JSON.stringify(message));
  }
}

// The blackout is used to stop cascading message loops.
function _startBlackout() {
  _blackout = true;
  setTimeout(() => {_blackout = false;}, 1000);
}

export const interTab = store => next => action => {
  const current_active_point = store.getState().point.latlng;

  switch (action.type) {
    case ActionTypes.SET_ACTIVE_POINT:
      if (_hasMoved(current_active_point, action.latlng)) {
        _sendMessage(action);
      }
      break;
    case ActionTypes.STORAGE_EVENT:
      if (store.getState().view.pop_out) {
        _handleStorageEvent(action.event, store.dispatch);
      }
      break;
    default:
      break;
  }

  return next(action);
};

export const _handleStorageEvent = (event, dispatch) => {
  if (event && event.newValue && event.key === INTER_TAB_STORAGE_KEY) {
    const message = JSON.parse(event.newValue);
    if (message.from !== _instanceId) {
      switch (message.type) {
        case ActionTypes.SET_ACTIVE_POINT:
          _startBlackout();
          dispatch(setActivePoint(message.action.latlng.lat, message.action.latlng.lng, false, true));
          break;
        default:
          break;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/middleware/interTabMiddleware.js